import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=6fd83870&"
import script from "./topic.vue?vue&type=script&lang=ts&"
export * from "./topic.vue?vue&type=script&lang=ts&"
import style0 from "./topic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports